// components
import GridPageAbstract from '../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../utils/gridHeadStorage';
import { PROXY_STATUS } from '../../constants/proxyStatus';

/**
 * Every proxy of every proxy list, with its state: working, or set aside after a job
 * failed through it, how many jobs have, and core-cron's rechecks of it. Shown as
 * scheme://host:port; the credentials are only in the list's text.
 *
 * Read and delete only: a proxy is added by editing its list, and its state is
 * core's and core-cron's to write. Deleting one here is the same as removing its
 * line from the list.
 */
export default class ProxiesPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'publicProxies';
        this.Server = this.props.context.getState().server.publicProxies;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['url'];
        this.showDatePicker = false;
        this.disableGlobalEditor = true;
        this.disableAdd = true;
        // Seeds the list filter when arriving from a list's "Proxies".
        this.hasCustomLogicOnMount = true;

        const defaultHead = [
            {
                id: 'proxyListId',
                label: 'proxyList',
                alignRight: false,
                cell: 'Select',
                // `from` is what loads the lists the filter offers.
                from: 'publicProxyLists',
                object: 'proxyList',
                show: 'name',
                filterCell: 'Context',
                filterBy: 'publicProxyLists',
                displayGrid: true,
                disableEditor: true,
                customSort: 'proxyList.name'
            },
            // No sort: the column is the url redacted, and a sort on the url itself
            // would order rows by their credentials (the backend refuses it).
            { id: 'proxy', label: 'proxy', alignRight: false, cell: 'Text', displayGrid: true, disableEditor: true, disableSort: true },
            {
                id: 'status',
                label: 'status',
                alignRight: false,
                cell: 'Items',
                items: PROXY_STATUS,
                enumGroup: 'proxyStatus',
                displayGrid: true,
                disableEditor: true
            },
            { id: 'failureCount', label: 'failureCount', alignRight: false, cell: 'Text', displayGrid: true, disableEditor: true },
            { id: 'failedRechecks', label: 'failedRechecks', alignRight: false, cell: 'Text', displayGrid: true, disableEditor: true },
            { id: 'lastError', label: 'lastError', alignRight: false, cell: 'BigText', displayGrid: true, disableEditor: true },
            { id: 'failedAt', label: 'failedAt', alignRight: false, cell: 'DateTime', displayGrid: true, disableEditor: true },
            { id: 'checkedAt', label: 'checkedAt', alignRight: false, cell: 'DateTime', displayGrid: true, disableEditor: true },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated'
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);

        this.state = {
            ...this.state,
            head: this.Head
        };
    }

    /**
     * Arriving from a list's row: filter to that list, in the same group the
     * toolbar's list filter writes, so it shows as a chip and is removed the same way.
     */
    async customLogicOnMount() {
        const proxyListId = this.props.location?.state?.proxyListId;
        if (!proxyListId) return;

        this.fs
            .clearGroup('prefilterFilter')
            .addGroup([{ field: 'proxyList.id', op: '@', value: [proxyListId] }], 'prefilterFilter');
        await this.setStateAsync({ filterActive: true, page: 0 });
    }
}
